import _ from 'underscore';
import isomorphicFetch from 'isomorphic-fetch';
import { urls } from './urls';
import { urlParse } from './base';

let fetch_data;

export var codeTypes = {
    success: 1000
};

export function filterRequestData(data, cfg) {
    if (!data) return data;

    let { sessionKey, groupKey, userKey } = _.extend({
        sessionKey: 'session',
        groupKey: 'group',
        userKey: 'user'
    }, cfg);


    data[sessionKey] && (data[sessionKey] = _.pick(data[sessionKey], 'id', 'session_type', 'jid', 'name'));
    data[groupKey] && (data[groupKey] = _.pick(data[groupKey], 'id', 'jid', 'name'));
    data[userKey] && (data[userKey] = _.pick(data[userKey], 'id', 'jid', 'nick_name'));
    return data;
}

export function filterResponseData(data) {
    return _.omit(data, 'ok', 'code', 'message');
}

export function setupFetchData(data) {
    fetch_data = data;
}

export function fetch(url, options = {}) {
    if (!url) return url;

    let method = options.method || 'GET';
    let data = options.body || options.data || {};
    let type = options.type || 'json'; //text、html、json、blob、arrayBuffer、formData
    let apiRoot = options.apiRoot || urls.api.root;
    let isAbsolute = options.isAbsolute || /^(http[s]?:)?\/\//i.test(url); //absolute url
    let logPrefix;

    const contentTypes = {
        text: 'text/plain',
        html: 'text/html',
        json: 'application/json',
        formData: 'multipart/form-data'
    };
    
    options = options || {};
    options.method = method;
    //formData 设置headers会报错
    if (options.type !== 'formData') {
        options.headers = _.extend({
            'Content-Type': contentTypes[type] || contentTypes.json
        }, options.headers);
    }
    

    if (_.contains(['GET', 'HEAD'], method)) {
        url += '?' + urlParse(_.extend({}, data, fetch_data));
    } else {
        if (type === 'json') {
            data = JSON.stringify(_.extend({}, data, fetch_data));
        }
        options.body = data;
    }

    options = _.omit(options, 'type', 'data', 'apiRoot');
    !isAbsolute && (url = urls.pathJoin(apiRoot, url));
    logPrefix = `[${options.method}][${url}]`;

    return isomorphicFetch(url, options).then((response) => {
        if (response.status === 204) {
            return response;
        } 
        if (!_.contains([200, 304], response.status)) {
            throw new Error(response.statusText + '（404）');
        }
        return response[type] ? response[type]() : response.json();
    }).then((res) => {
        if (res.status === 204) {
            return res;
        }
        res.ok = res.code == codeTypes.success;
        res.message = res.detail || res.message;
        if (!res.ok) {
            console.warn(`${logPrefix}[${res.code||res.status}]`, res, options);
        }
        return res;
    }).catch((error) => {
        console.error(`${logPrefix}`, error, options);
        return error;
    });
}


// WEBPACK FOOTER //
// ./src/utils/fetch.js